import { render } from "./ConfigCards.vue?vue&type=template&id=3c76b98c"
import script from "./ConfigCards.vue?vue&type=script&lang=js"
export * from "./ConfigCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__